import React from 'react';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useActions } from '../services/index.tsx';
import type { TaskId } from '../tasks/constants.tsx';
import messages from './TaskCompleteButton.messages.tsx';

export const TaskCompleteButton = ({ taskId }: { taskId: TaskId }): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { completeTaskAndContinue } = useActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = () => {
		completeTaskAndContinue({ id: taskId });
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'completeTask', {
			taskId,
		});
	};

	return (
		<Button appearance="discovery" onClick={handleClick}>
			{formatMessage(messages.completeButton)}
		</Button>
	);
};
